import { reflect } from '@effector/reflect';
import { useUnit } from 'effector-react';
import { CircleSlash2 } from 'lucide-react';
import { equals, not } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { USER_ROLES } from 'shared/api';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { BlockJackpotModel } from '../../model';

export const createBlockJackpotModal = (model: BlockJackpotModel) => {
	const ConfirmModal = createConfirmModal(model);

	const BlockJackpotModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [jackpot] = useUnit([model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('block-jackpot.title')}
				cancelButtonProps={{
					children: t('block-jackpot.cancel'),
				}}
				submitButtonProps={{
					variant: 'outline',
					children: t('block-jackpot.block'),
				}}
				{...props}
			>
				{t('block-jackpot.description', {
					currency: jackpot?.currency,
					type: t(`jackpot-types.${jackpot?.type}`),
				})}
			</ConfirmModal>
		);
	});

	const BlockJackpotModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'block-jackpot-action-icon',
			variant: 'ghost-secondary',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			children: <CircleSlash2 />,
		},
	});

	return Object.assign(BlockJackpotModal, {
		ActionIcon: BlockJackpotModalActionIcon,
	});
};
